export default __webpack_public_path__ + "static/font-5d944b8e95ba8e59008173e17e62d61d.woff";